import { Pipe, PipeTransform } from '@angular/core';

export interface WeekViewHourSegment {
  isStart: boolean;
  date: Date;
  displayDate: Date;
  cssClass?: string;
}

@Pipe({
  name: 'timeFormatHour',
  standalone: true,
})
export class TimeFormatHourPipe implements PipeTransform {
  transform(value: WeekViewHourSegment): string {
    const date = new Date(value.date);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    if (value.isStart) return `${hours}:${minutes}`;
    return '';
  }
}
@Pipe({
  name: 'timeFormatMinute',
  standalone: true,
})
export class TimeFormatMinutePipe implements PipeTransform {
  
  transform(value: WeekViewHourSegment): string {
    const date = new Date(value.date);
    const minutes = String(date.getMinutes()).padStart(2, '0');

    if (!value.isStart) return `${minutes}`;
    else return '';
  }
}

@Pipe({
  name: 'timeTransformerDefault',
  standalone: true,
})
export class TimeTransformerDefault implements PipeTransform {
  
  transform(date: Date | string | null): string {
    if (!date) return '';

    const dateObj = date instanceof Date ? date : new Date(date);

    if (isNaN(dateObj.getTime())) return '';

    const formattedDate = `${String(dateObj.getDate()).padStart(2, '0')}/` +
                          `${String(dateObj.getMonth() + 1).padStart(2, '0')}/` +
                          `${dateObj.getFullYear()} ` +
                          `${String(dateObj.getHours()).padStart(2, '0')}:` +
                          `${String(dateObj.getMinutes()).padStart(2, '0')}`;

    return formattedDate;
  }
}

